const Community = () => {
  return (
    <section className="py-40 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        {/* 右にズラした枠 */}
        <div className="w-[75%] ml-auto mr-0 md:mr-12">
          <div className="border border-border p-12 md:p-16">
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-light mb-6 text-right">
              静かに遊べる人たちの、小さな集まりです。
            </p>
            <p className="text-sm text-muted-foreground/70 leading-relaxed font-light text-right">
              盛り上がらなくていいやつ。
            </p>
          </div>
        </div>
        
        {/* 浮かぶ小さな点 - 装飾 */}
        <div className="mt-16 ml-8">
          <div className="w-2 h-2 bg-primary/20 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default Community;